import { makeStyles } from '@material-ui/core/styles';

export const topNavHeight = 44;

const useStyles = makeStyles((theme) => ({
    topNav: {
        '&.MuiAppBar-colorPrimary': {
            '@media print': {
                backgroundColor: theme.palette.background.paper,
            },
        },

        '& .MuiToolbar-root': {
            height: topNavHeight,
            minHeight: topNavHeight,
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2) - 2, // Subtact 2 to match portal/ui UI :(

            '@media print': {
                paddingLeft: 0,
                paddingRight: 0,
            },
        },
    },
    menuButton: {
        '&.MuiIconButton-root': {
            padding: 10,

            '@media print': {
                display: 'none',
            },
        },
    },
    productLogo: {
        width: 135,
        height: 18,
        marginLeft: 4,
        position: 'relative',
        top: 1,
        cursor: 'pointer',
    },
    logoContainer: {
        ...theme.mixins.flex.grow(1),
    },
    actionContainer: {
        ...theme.mixins.flex.displayFlex,
        ...theme.mixins.flex.alignItemsCenter,
        ...theme.mixins.flex.justifyContentFlexEnd,

        height: '100%',

        // '& > *' is not specific enough, in prod rules evaluate in different order and this doesn't apply to everything
        '& > .action-item': {
            height: '100%',
            marginLeft: 28,

            ...theme.mixins.flex.displayFlex,
            ...theme.mixins.flex.alignItemsCenter,

            '& > *': {
                ...theme.mixins.flex.displayInlineFlex,
                ...theme.mixins.flex.alignItemsCenter,
            },
        },

        '& a, & button': {
            color: theme.palette.primary.contrastText,
        },

        '@media print': {
            display: 'none',
        },
    },
}));

export default useStyles;
